module.exports = __webpack_public_path__ + "static/favicon-adaa08fd430281689affd43af67cc675.png";